import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    tasks: {
        url: `${customerApi}/api/group-sop/tasks`,
        type: 'GET',
    },
    createTasks: {
        url: `${customerApi}/api/group-sop/tasks`,
        type: 'POST',
    },
    tasksInfo: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}`,
        type: 'GET',
    },
    tasksModify: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}`,
        type: 'PUT',
    },
    tasksDelete: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}`,
        type: 'DELETE',
    },
    tasksChats: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}/chats`,
        type: 'GET',
    },
    createTasksChats: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}/chats`,
        type: 'POST',
    },
    tasksStatusModify: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}/status`,
        type: 'POST',
    },
    tasksChatsDelete: {
        url: `${customerApi}/api/group-sop/tasks/{task_id}/chats/{chat_id}`,
        type: 'DELETE',
    },
}
